import {TranslateService} from '@ngx-translate/core';
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {ActivatedRoute, Router} from '@angular/router';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import {environment} from '../../../environments/environment';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import {venueAcceptsOrders} from '../../../smoothr-web-app-core/utils/utils';
import {NavigationService, NAVIGATIONURLS} from 'src/app/services/navigation.service';
import {MapsUtils} from 'src/maps/utils/maps';
import {GetAddressModalComponent} from 'src/app/components/get-address-modal/get-address-modal.component';
import {ModalController} from '@ionic/angular';

enum Language {
	GreatBritain = 'en',
	German = 'de'
}

@Component({
	selector: 'app-home',
	templateUrl: './home.page.losteria.html',
	styleUrls: ['./home.page.losteria.scss']
})
export class HomePage extends RepositoryDirective implements OnInit {
	static url = 'home';
	environment = environment;
	languageEnum = Language;

	loading = false;
	preorderTypes = [PreorderType.INSIDE, PreorderType.TAKE_AWAY];
	active: any = {};
	modalIsActive = false;

	constructor(
		protected repository: RepositoryService,
		private modalCtrl: ModalController,
		public translate: TranslateService,
		private navigationService: NavigationService,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute
	) {
		super(repository);
	}
	ngOnInit() {
		super.ngOnInit();
		this.loading = true;
		this.loadVenues();
		this.route.queryParams.subscribe(v => {
			if (v.openGetAdressModal) {
				this.locateAndShowStores();
			}
		});
	}

	ionViewDidEnter() {
		if (history.state.navigationId === 1) {
			this.repository.order.emit(null);
		}
		this.repository.verifiedOrder.emit(null);
	}

	async locateAndShowStores() {
		this.modalIsActive = true;
		this.cdr.detectChanges();
		const response = await GetAddressModalComponent.show(this.modalCtrl);
		this.modalIsActive = false;
		if (response) {
			this.navigationService.map();
			this.repository.address.emit(response);
		}
		this.cdr.detectChanges();
	}

	loadVenues() {
		for (const preorderType of this.preorderTypes) {
			this.active[preorderType] = false;
		}
		new Promise<void>(async (resolve, reject) => {
			try {
				const venues = await this.repository.getAllVenues();
				for (const venue of venues) {
					for (const preorderType of this.preorderTypes) {
						this.active[preorderType] = this.active[preorderType] || venueAcceptsOrders(venue, preorderType);
					}
				}
				resolve();
			} catch (e) {
				reject(e);
			}
		}).finally(() => (this.loading = false));
	}
	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
	}
}
